import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-search-card" }
const _hoisted_2 = { class: "price-search-card__top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "price-search-card__title" }, " Ihre Angaben ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "font-regular" }, " Ihre Postleitzahl ", -1)
const _hoisted_5 = { class: "font-regular" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "font-regular" }, " Ihr Verbrauch / Jahr ", -1)
const _hoisted_7 = { class: "font-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!
  const _component_Expand = _resolveComponent("Expand")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.options.postcode), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatNumber(_ctx.options.usage, 0)) + " kWh ", 1)
        ])
      ])
    ]),
    _createVNode(_component_Expand, {
      title: "Angaben ändern",
      type: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseCalculator, {
          postcode: _ctx.options.postcode,
          "preselected-options": _ctx.options,
          "force-visibility": true,
          type: "component"
        }, null, 8, ["postcode", "preselected-options"])
      ]),
      _: 1
    })
  ]))
}